/** Persisted list scope: mine | workspace | others_private */
export const LEADS_LIST_SCOPE_KEY = 'up2promo.leads.listScope';
